import React from 'react';
import PropTypes from 'prop-types';

import {Typography, Stack, Box, Link} from 'views/components';
import {Translate} from 'views/module';
import {TicketLogo, PagerLogo, RunbookLogo, PulseLogo, AlarmLogo} from 'views/icons';

const isActive = (type, activeIcons) => {
  return activeIcons && !activeIcons[type];
};
const filterActive = (type, activeIcons) => {
  if (isActive(type, activeIcons)) {
    return {
      p: '8px',
    };
  } else {
    return {
      backgroundColor: 'secondary.light',
      borderRadius: '8px',
      p: '8px',
    };
  }
};

const ICONS = {
  'TICKET': {
    title: 'generic.Product.Ticketing',
    logo: TicketLogo,
    link: '/product/ticketing/',
  },
  'PAGER': {
    title: 'generic.Product.Pager',
    logo: PagerLogo,
    link: '/product/pager/',
  },
  'RUNBOOK': {
    title: 'generic.Product.Runbook',
    logo: RunbookLogo,
    link: '/product/runbook/',
  },
  'PULSE': {
    title: 'generic.Product.Pulse',
    logo: PulseLogo,
    link: '/product/pulse/',
  },
  'ALARM': {
    title: 'generic.Product.Alarm',
    logo: AlarmLogo,
    link: '/product/alarm/',
  },
};

const IconList = (props) => {
  const iconSize = '24px';

  const activeIcons = props.activeIcons;

  return (
    <Stack
      direction="row"
      spacing={{md: 6, xs: 0.5}}
      useFlexGap
      flexWrap="wrap"
      sx={{
        m: {md: '0px', xs: 'auto'},
        px: {md: '0px', xs: '16px'},
      }}
    >
      {
        Object.entries(ICONS).map(([key, value]) => {
          const Logo = value.logo;
          return (
            <Box
              key={key}
              sx={{
                ...filterActive(key, activeIcons),
                m: {md: '0px', xs: 'auto'},
                minWidth: '128px',
              }}
            >
              <Link to={value.link} underline="hover">
                <Logo
                  sx={{
                    margin: 'auto',
                    width: iconSize,
                    height: iconSize,
                  }}
                />
                <Typography variant='logo4'
                  sx={{
                    pl: '4px',
                  }}
                >
                  <Translate expression={value.title} />
                </Typography>
              </Link>
            </Box>
          );
        })
      }
    </Stack>
  );
};

IconList.propTypes = {
  activeIcons: PropTypes.object,
};

export default IconList;
